import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PreviewResultsBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  .preview-results-bar-container {
    /** conversion from a .css file */
    display: flex;
    justify-content: flex-end;
    .userInput {
      width: ${pxToRem(300)};
      margin-right: 0;
    }
  }
`;

export const PreviewRadioButtonAndLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.quarter};
  margin-right: ${spacing.base};

  label {
    margin: 0;
  }
`;
